import { saveAs } from "file-saver"

const mimeTypes = {
   docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
   pdf: "application/pdf",
   xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
   doc: "application/msword",
   xls: "application/vnd.ms-excel",
   png: "image/png",
   jpg: "image/jpeg",
   jpeg: "image/jpeg",
   gif: "image/gif",
}

function getPrepend(ext) {
   return `data:${mimeTypes[ext]};base64`
}

function getExtFromBase64(base64) {
   if (typeof base64 !== "string") {
      throw new Error("base64 must be a string")
   }
   const ext = Object.keys(mimeTypes).find((key) => base64.indexOf(getPrepend(key)) === 0)
   if (!ext) {
      throw new Error(`Invalid or unsupported base64 extension. Supported: ${Object.keys(mimeTypes).join(", ")}`)
   }
   return ext
}

function base64ToBlob(base64String, contentType) {
   const byteChars = atob(base64String)
   const byteArrays = []
   for (let offset = 0; offset < byteChars.length; offset += 512) {
      const slice = byteChars.slice(offset, offset + 512)
      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
         byteNumbers[i] = slice.charCodeAt(i)
      }
      byteArrays.push(new Uint8Array(byteNumbers))
   }
   return new Blob(byteArrays, { type: contentType })
}

export function triggerBase64Download(base64, name = "download") {
   const ext = getExtFromBase64(base64)
   const prepend = getPrepend(ext)
   const contentType = mimeTypes[ext]
   const cleanedBase64 = base64.replace(`${prepend},`, "")
   const blob = base64ToBlob(cleanedBase64, contentType)
   const file = new File([blob], `${name}.${ext}`, { type: contentType })
   saveAs(file)
}
